import { render, staticRenderFns } from "./CotizrHeader.vue?vue&type=template&id=8b8762aa&scoped=true&"
import script from "./CotizrHeader.vue?vue&type=script&lang=js&"
export * from "./CotizrHeader.vue?vue&type=script&lang=js&"
import style0 from "./CotizrHeader.vue?vue&type=style&index=0&id=8b8762aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8762aa",
  null
  
)

export default component.exports